// src/utils/services/googleMapsLoader.ts
import { Loader } from '@googlemaps/js-api-loader';

export class GoogleMapsLoader {
  private static instance: GoogleMapsLoader;
  private loader?: Loader;
  private mapsLibraryPromise?: Promise<google.maps.MapsLibrary>;
  private apiKey: string = '';

  private constructor() {}

  public static getInstance(): GoogleMapsLoader {
    if (!GoogleMapsLoader.instance) {
      GoogleMapsLoader.instance = new GoogleMapsLoader();
    }
    return GoogleMapsLoader.instance;
  }

  public init(googleMapsApiKey: string): void {
    if (googleMapsApiKey === '') {
      googleMapsApiKey = process.env.GOOGLE_MAPS_API_KEY || '';
    }
    this.apiKey = googleMapsApiKey;
  }

  public load(): Promise<google.maps.MapsLibrary> {
    if (this.mapsLibraryPromise) {
      return this.mapsLibraryPromise;
    }

    this.apiKey = this.apiKey ==='' ? process.env.GOOGLE_MAPS_API_KEY || '' : this.apiKey;

    if (this.apiKey === '') {

      throw new Error('Google Maps API key is missing');
    }

    this.loader = new Loader({
      apiKey: this.apiKey,
      version: 'weekly',
      libraries: ['places', 'geometry', 'marker'],
      region: 'EU',
    });

    this.mapsLibraryPromise = this.loader.importLibrary("maps") as Promise<google.maps.MapsLibrary>;
    return this.mapsLibraryPromise;
  }
}

export const googleMapsLoader = GoogleMapsLoader.getInstance();
